import { attr } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const District = ApplicationRecord.extend({
  static: {
    jsonapiType: 'districts',
  },
  attrs: {
    name: attr(),
  },
})

export default District
